import { $http } from '../config';

const Roles = {
	getRoles: () => $http(`/roles`).then(r => r.data),
	createRole: (name, description, permissions) =>
		$http.post(`/roles`, { name, description, permissions }).then(r => r.data),
	deleteRole: rolId => $http.delete(`/roles/${rolId}`).then(r => r.data),
	updateRole: (roleId, { name, description, permissions, disabled }) =>
		$http.put(`/roles/${roleId}`, { name, description, permissions, disabled }).then(r => r.data)
};

export default Roles;
